import React from 'react';
import { SonarText } from '@ui/text';
import { useNavigate } from 'react-router-dom';

export interface NotificationLinkDescriptionProps {
	linkLabel: string;
	message: string;
	navigate: ReturnType<typeof useNavigate>;
	showLink: boolean;
	target: string;
}

export const NotificationLinkDescription: React.FC<NotificationLinkDescriptionProps> = ({
	linkLabel,
	message,
	navigate,
	showLink,
	target
}) =>
	<SonarText>
		{ message }
		<br />
		{ showLink &&
			<SonarText
				link
				onClick={ () => navigate(target) }>
				{ linkLabel }
			</SonarText> }
	</SonarText>;

